import { createTheme } from "@mui/material/styles";
import { themePalette } from "./colors";

export const themeLayout = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  components: {
    MuiListItemButton: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            color: themePalette.palette.primary.main,
            "&:hover": {
              backgroundColor: "rgba(95, 185, 42, 0.08)",
            },
          },
        },
      },
    },
  },
});
